import axios from "../utils/axios";

// ==========================================
// Returns (Admin)
// ==========================================

export const getReturns = async (params) => {
    const response = await axios.get("/admin/returns", { params });
    return response.data;
};

export const getReturnById = async (id) => {
    const response = await axios.get(`/admin/returns/${id}`);
    return response.data;
};

export const approveReturn = async (id, data) => {
    const response = await axios.post(`/admin/returns/${id}/approve`, data);
    return response.data;
};

export const rejectReturn = async (id, data) => {
    const response = await axios.post(`/admin/returns/${id}/reject`, data);
    return response.data;
};

export const receiveReturn = async (id, data = {}) => {
    const response = await axios.post(`/admin/returns/${id}/receive`, data);
    return response.data;
};

export const completeReturn = async (id) => {
    const response = await axios.post(`/admin/returns/${id}/complete`);
    return response.data;
};

export const refundCompleteReturn = async (id, data = {}) => {
    const response = await axios.post(`/admin/returns/${id}/refund-complete`, data);
    return response.data;
};

export const cancelReturn = async (id, data = {}) => {
    const response = await axios.post(`/admin/returns/${id}/cancel`, data);
    return response.data;
};
